<script>

    import { toast } from 'bulma-toast'
    import { shipmentsStore, shipmentsSelectedStore, modalStore } from '../stores'

    import ShipmentsService from '../$services/shipments.service'
    import DateMethods from '../$methods/date.method.js'
    import TranslateMethods from '../$methods/translate.methods.js'
    import NumeralMethods from '../$methods/numeral.methods.js'

    import ShipmentsTracingReportComponent from './component.shipments.tracing.report.svelte'
    import TrackingAutomaticComponent from '../trackings/component.tracking.automatic.svelte'

    import Search from '../$components/input.search.svelte'
    import Select from '../$components/select.svelte'
    import Pagination from '../$components/pagination.svelte'
    import Table from '../$components/table.svelte'
    import TableStatus from '../$components/table.status.svelte'
    import Button from '../$components/button.svelte'
    import ButtonModal from '../$components/button.modal.svelte'
    import SelectProvider from '../$components/select.providers.svelte'

    let metadata = {}
    let shipmentsTotal = 0
    let checkedGlobal = false
    let loading = false

    let query = {
        admin: true,
        page: 0,
        find: null,
        created: -1,
        trackingStatus: ''
    }

    getShipments()

    async function getShipments(reset = false) {

        if(reset === true)
            query.page = 0

        loading = true
        const resp = await ShipmentsService.getShipments(query)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        metadata = resp.data.metadata
        shipmentsTotal = resp.data.shipmentsTotal
        shipmentsStore.set(resp.data.shipments)
    }

    function verifyCheckeds() {
        setTimeout(() => {

            let isShipmentsChecked = false

            $shipmentsStore.forEach(order => {
                if(order.checked)
                    isShipmentsChecked = true
            })

            checkedGlobal = isShipmentsChecked
        }, 100)
    }

    function onCheckedGlobal() {
        checkedGlobal = !checkedGlobal
        shipmentsStore.set($shipmentsStore.map(shipment => {

            if(shipment.status === 'progress')
                shipment.checked = checkedGlobal

            return shipment
        }))
    }

    function downloadGuides() {
        const shipments = $shipmentsStore.filter(shipment => shipment.checked && shipment.status === 'progress')
        shipmentsSelectedStore.set(shipments)
        modalStore.set('shipments_download_modal')
    }

</script>

<Table items={ $shipmentsStore.length } total={ metadata.total } { loading }>
    <div slot="toolbar">
        <div class="columns is-multiline is-align-items-flex-end mb-0">
            {#if checkedGlobal}
                <div class="column is-narrow">
                    <div>
                        <button type="button" on:click={downloadGuides} class="button is-primary">
                            <span class="icon"><i class="fas fa-file-download"></i></span>
                            <span>Descargar guías</span>
                        </button>
                    </div>
                </div>
            {/if}
            <div class="column">
                <Search
                    bind:value={ query.find }
                    on:enter={() => getShipments(true)}
                    placeholder="Buscar guía, usuario o correo…"
                />
            </div>
            <div class="column is-narrow">
                <SelectProvider bind:provider={ query.provider } on:change={ getShipments } isLabel={false} />
            </div>
            <div class="column is-narrow">
                <Select
                    bind:value={ query.trackingStatus }
                    on:change={ getShipments }
                    text="Estatus"
                    options={[
                        {value: 'Guía generada', text: 'Guía generada'},
                        {value: 'Guía no usada', text: 'Guía no usada'},
                        {value: 'En camino', text: 'En camino'},
                        {value: 'Guía sin movimiento', text: 'Guía sin movimiento'},
                        {value: 'Revisión', text: 'Revisión'},
                        {value: 'Entregado', text: 'Entregado'},
                        {value: 'Cancelado', text: 'Cancelado'},
                        {value: 'Reembolso pendiente', text: 'Reembolso pendiente'},
                        {value: 'Reembolsado', text: 'Reembolsado'},
                    ]}
                />
            </div>
            <div class="column is-narrow">
                <div>
                    {#if query.trackingStatus != 'Entregado'}
                        <TrackingAutomaticComponent />
                    {/if}
                    {#if query.trackingStatus === 'Revisión'}
                        <ShipmentsTracingReportComponent />
                        <ButtonModal modalId="shipments_tracing_report_upload_modal" icon="file-upload" text="Subir reporte" />
                    {/if}
                    <ButtonModal modalId="shipments_report_modal" icon="file-download" text="Descargar reporte" />
                </div>
            </div>
        </div>
    </div>
    <div slot="footer">
        <Pagination bind:metadata bind:page={ query.page } on:change={ getShipments } />
    </div>
    <thead>
        <tr>
            <th class="col-index">#</th>
            <th>Usuario</th>
            <th>Servicio</th>
            <th class="col-numeric">Precio</th>
            <th>Estatus</th>
            <th>
                <button
                    type="button"
                    class="app-table-th-sort"
                    aria-label="Ordenar por fecha"
                    on:click={() => {
                        query.created = query.created * -1
                        getShipments()
                    }}
                >
                    <span>Fecha</span>
                    <span class="icon"><i class="fas fa-sort" aria-hidden="true"></i></span>
                </button>
            </th>
            <th class="col-actions">Acciones</th>
        </tr>
    </thead>
    <tbody>
        {#each $shipmentsStore as shipment, index }
            <tr
                class:app-table-row--alert={ DateMethods.isAfter12(shipment.tracing? shipment.tracing.updated : null) }
            >
                <td class="col-index">{(metadata.items * query.page) + (index + 1)}</td>
                <td>
                    <div class="app-table-cell-stack">
                        <span class="app-table-cell-primary">{shipment.user.name}</span>
                        <span class="app-table-cell-secondary">{shipment.user.email}</span>
                    </div>
                </td>
                <td>
                    <div class="app-table-cell-stack">
                        <span class="app-table-cell-primary">{shipment.provider}</span>
                        <span class="app-table-cell-secondary">
                            {shipment.service}
                            <span class="app-table-tag">{shipment.order.package.volumetric} Kg</span>
                        </span>
                    </div>
                </td>
                <td class="col-numeric">
                    <span class="app-table-cell-amount">{NumeralMethods.cash(shipment.pricing.finalPrice)}</span>
                </td>
                <td>
                    <TableStatus label={shipment.trackingStatus} />
                </td>
                <td>
                    <span class="app-table-cell-secondary">{DateMethods.dateTimeLarge(shipment.created)}</span>
                </td>
                <td class="col-actions">
                    <Button on:click={() => modalStore.open('shipment', 'modal', shipment)} icon="ellipsis-v" />
                </td>
            </tr>
        {/each}
    </tbody>
</Table>